import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Navbar } from "../../Components/HomeV2/Navbar";
import { HeroSection } from "../../Components/HomeV2/HeroSection2";
import { FeaturesCards } from "../../Components/HomeV2/FeaturesCards";
import { AboutLegends } from "../../Components/HomeV2/AboutLegends";
import { SecretMap } from "../../Components/HomeV2/SecretMap";
import { ExploreBlock } from "../../Components/HomeV2/ExploreBlock";
import { Reviews } from "../../Components/HomeV2/Reviews";
import { Footer } from "../../Footer/Footer";

import "./HomePage.css";
import { ExploreShlokMonumentBlock } from "../../Components/HomeV2/ExploreShlokMonumentBlock";
import { HowItWorks } from "../../Components/HomeV2/HowItWorks";

export const HomePage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [plans, setPlans] = useState(null);
  const [plansLoading, setPlansLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${apiUrl}/plans`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Failed to fetch plans");
        const data = await res.json();
        setPlans(data);
      } catch (err) {
        console.error("Error fetching plans:", err);
        // Fail silently — page still renders, price badge simply won't show
      } finally {
        setPlansLoading(false);
      }
    };
    fetchPlans();
  }, [apiUrl]);

  return (
    <div className="homeV2Page">
      <Helmet>
        <title>Yuva Quest | Connect with Culture</title>
        <meta
          name="description"
          content="Yuva Quest helps parents and educators connect kids to Indian culture through engaging quests, stories, and history-based fun."
        />
        <link rel="canonical" href="https://yuvaquest.com" />
      </Helmet>

      <Navbar />

      <main className="homeV2Page__main">
        <HeroSection plans={plans} plansLoading={plansLoading} />

        <HowItWorks />

        <AboutLegends />

        <SecretMap />

        <FeaturesCards />

        <ExploreBlock
          id="explore-festivals"
          title="Explore Indian Festivals"
          description="Our interactive Festival Map lets kids explore the meaning, stories, and traditions behind each celebration in a fun and visual way. It's a joyful journey through India's rich cultural heritage, one festival at a time!"
          image={`${process.env.REACT_APP_CDN_URL}/static/homev2/Indian-Festival-Map.6a3ae0f3539d808b890b.jpg`}
          imageAlt="Interactive Indian Festival Map"
        />

        <ExploreShlokMonumentBlock />

        <Reviews />
      </main>

      <Footer />
    </div>
  );
};
